import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgHcaptchaModule } from 'ng-hcaptcha';
import { CarouselModule } from 'primeng/carousel';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MenubarModule } from 'primeng/menubar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import React from 'react';
import { CookieConsentComponent } from 'src/app/components/cookie-consent/cookie-consent.component';
import { NotFoundComponent } from 'src/app/components/not-found/not-found.component';
import { OfflineComponent } from 'src/app/components/offline/offline.component';
import { ModalModule } from 'src/app/modal';
import { ContentTooltipPipe } from 'src/app/pipes/content-tooltip.pipe';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AudiButtonComponent } from './components/audi/audi-button';
import { AudiCheckboxComponent } from './components/audi/audi-checkbox';
import { AudiLoaderComponent } from './components/audi/audi-loader';
import { AudiSelectComponent } from './components/audi/audi-select';
import { AudiTextComponent } from './components/audi/audi-text';
import { AudiTextFieldComponent } from './components/audi/audi-text-input';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { CustomerDetailsComponent } from './components/customer-details/customer-details.component';
import { CustomizePlanComponent } from './components/customize-plan/customize-plan.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { EnterCustomerDetailsComponent } from './components/enter-customer-details/enter-customer-details.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { NewPlanOptionComponent } from './components/new-plan-option/new-plan-option.component';
import { PaymentComponent } from './components/payment/payment.component';
import { SelectPlanComponent } from './components/select-plan/select-plan.component';
import { StartComponent } from './components/start/start.component';
import { TestComponent } from './components/test/test.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { VehicleDetailsJustBrowsingComponent } from './components/vehicle-details-just-browsing/vehicle-details-just-browsing.component';
import { ViewQuoteComponent } from './components/view-quote/view-quote.component';
import { VWSAButtonComponent } from './components/vwsa/vwsa-button';
import { VWSACheckboxComponent } from './components/vwsa/vwsa-checkbox';
import { VWSASelectComponent } from './components/vwsa/vwsa-select';
import { VWSASpinnerComponent } from './components/vwsa/vwsa-spinner';
import { VWSATextComponent } from './components/vwsa/vwsa-text';
import { VWSATextInputComponent } from './components/vwsa/vwsa-text-input';
import { HomeComponent } from './home/home.component';
import { ContentImagePipe } from './pipes/content-image.pipe';
import { ContentTextPipe } from './pipes/content-text.pipe';
import { RetryInterceptor } from './services/retry.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StartComponent,
    HeaderComponent,
    FooterComponent,
    EnterCustomerDetailsComponent,
    CustomerDetailsComponent,
    ContentTextPipe,
    ContentImagePipe,
    ContentTooltipPipe,
    DialogComponent,
    MenuComponent,
    SelectPlanComponent,
    NewPlanOptionComponent,
    CustomizePlanComponent,
    ViewQuoteComponent,
    ContactUsComponent,
    TestComponent,
    PaymentComponent,
    AudiButtonComponent,
    AudiTextComponent,
    AudiTextFieldComponent,
    AudiLoaderComponent,
    AudiSelectComponent,
    AudiCheckboxComponent,
    VWSAButtonComponent,
    VWSATextComponent,
    VWSATextInputComponent,
    VWSASpinnerComponent,
    VWSASelectComponent,
    VWSACheckboxComponent,
    VehicleDetailsJustBrowsingComponent,
    TooltipComponent,
    CookieConsentComponent,
    OfflineComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    DialogModule,
    DynamicDialogModule,
    TabViewModule,
    TableModule,
    ProgressSpinnerModule,
    CarouselModule,
    MenubarModule,
    TooltipModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NgHcaptchaModule.forRoot({ siteKey: environment.brand == 'audi' ? environment.captchaKey_audi : environment.captchaKey_vwsa }),
    ModalModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    window.React = React;
  }
}
